import DefaultSection from './DefaultSection';

export default DefaultSection;
